import AdminConsolePage from "./admin_console/AdminConsolePage";
export default AdminConsolePage;
